import { Injectable } from '@angular/core';
import {OverlayService} from "../overlay/overlay.service";
import {AlertLargeComponent} from "../shared/alert-large/alert-large.component";
import {AlertLargeFooterComponent} from "../shared/alert-large/alert-large-footer/alert-large-footer.component";

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  constructor(private overlay: OverlayService) { }

  showAlert(text: string, headerText: string, buttonLabel: string): void {
    this.overlay.openWindowOverlay({
      theme: "blue",
      title: headerText,
      componentMain: {
        component: AlertLargeComponent,
        data: {
          text: text
        }
      },
      componentFooter: {
        component: AlertLargeFooterComponent,
        data: {
          text: buttonLabel
        }
      }
    })
  }
}
